import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  footer: {
    defaultMessage: 'Powered by Jira Service Management',
    description: 'Message displayed in the company hub footer',
    id: 'company-hub.hub-app-shell.footer.powered.by.jira.service.management'
  }
});